import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton, Stack } from '@mui/material';

EmiBox.propTypes = {
  LoanPercentage: PropTypes.number.isRequired,
  productPrice: PropTypes.number.isRequired,
  mt: PropTypes.any,
};

export default function EmiBox({ LoanPercentage, productPrice, mt }) {
  // console.log(mt);
  const [years, setYears] = useState(5);

  const handleIncrement = () => {
    if (years < 6) setYears((prev) => prev + 1);
  };

  const handleDecrement = () => {
    if (years > 1) setYears((prev) => prev - 1);
  };

  // Step 1: Down Payment
  const loanFraction = LoanPercentage / 100;
  const loanAmount = productPrice * loanFraction;
  const downPayment = productPrice - loanAmount;

  // Step 2: EMI calculation using formula
  const emi = (loanAmount * (1 + 0.075 * years)) / (years * 12);

  const formattedDownPayment = `₹${Math.floor(downPayment).toLocaleString('en-IN')}`;
  const formattedEmi = `₹${Math.floor(emi).toLocaleString('en-IN')}`;

  return (
    <Box
      sx={{
        borderRadius: '10px',
        padding: '1px',
        background: 'linear-gradient(90deg, #333333 0%, #9E9E9E 49.07%, #333333 100%)',
      }}
    >
      <Box
        mt={mt && '5px'}
        sx={{
          // border: '1px solid #4a4a4a',

          borderRadius: '8px',
          padding: '15px',
          backgroundColor: '#121212',
          display: 'flex',
          flexDirection: 'column',
          color: '#fff',
          fontFamily: 'sans-serif',
          width: '100%',
        }}
      >
        {/* Top: Down Payment */}
        <Typography sx={{ fontSize: '14px', color: '#FFFFFF99' }}>
          Down Payment -&nbsp;&nbsp; {formattedDownPayment}/-
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
          }}
        >
          <Stack>
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-end',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Stack sx={{ mr: '5px' }}>
                    <Typography sx={{ fontSize: '16px', color: '#9DB9CD' }}>EMI</Typography>
                    <Typography sx={{ fontSize: '12px', color: '#9DB9CD' }}>Starts at</Typography>
                  </Stack>
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <Typography sx={{ fontSize: '24px', fontWeight: 600, color: '#F8971C' }}>{formattedEmi}</Typography>
                    <Box
                      component="span"
                      sx={{
                        position: 'absolute',
                        top: 2,
                        right: -7,
                        fontSize: '15px',
                        color: '#aaa',
                      }}
                    >
                      *
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: formattedEmi.replace(/[^0-9]/g, '').length > 5 ? '14px' : '16px',
                      marginLeft: '6px',
                      color: '#FFFFFF99',
                    }}
                  >
                    /month for
                  </Typography>
                </Box>
              </Box>
            </>
          </Stack>
          {/* Arrow control */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              // backgroundColor: '#1E1E1E',
              borderRadius: '6px',
              padding: '4px 2px',
              width: '32px',
            }}
          >
            <IconButton
              onClick={handleIncrement}
              size="small"
              sx={{
                color: '#fff',
                padding: '0px',
                minHeight: '24px',
                '&:hover': { background: 'none' },
              }}
            >
              {/* <ArrowDropUpIcon /> */}
              <Box
                component="img"
                src="/assets/images/Product/up.png"
                alt="Warranty Image"
                sx={{
                  width: '100%',
                  height: '28px',
                  objectFit: 'cover',
                  display: 'block',
                  borderRadius: '0px ',
                  minWidth: '46px',
                }}
              />
            </IconButton>

            <Typography sx={{ fontSize: '18px', color: '#F6851F', fontWeight: 500 }}>{years} </Typography>

            <IconButton
              onClick={handleDecrement}
              size="small"
              sx={{
                color: '#fff',
                padding: '0px',
                minHeight: '24px',
                '&:hover': { background: 'none' },
              }}
            >
              <Box
                component="img"
                src="/assets/images/Product/down.png"
                alt="Warranty Image"
                sx={{
                  width: '100%',
                  height: '28px',
                  objectFit: 'cover',
                  display: 'block',
                  borderRadius: '0px ',
                  minWidth: '46px',
                }}
              />{' '}
            </IconButton>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
              <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#FFFFFF99' }}>Years</Typography>
            </Box>
          </Box>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 400, fontSize: '12px', color: '#FFFFFF99' }}>
            * Actual rates may vary based on your CIBIL score
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
